import React from 'react';

import SvgContainer from '../SvgContainer';

const Mail = () => {
    return (
        <SvgContainer>
            <path d="M14.4 2H1.6C0.72 2 0.00799999 2.675 0.00799999 3.5L0 12.5C0 13.325 0.72 14 1.6 14H14.4C15.28 14 16 13.325 16 12.5V3.5C16 2.675 15.28 2 14.4 2ZM14.4 4.62916C14.4 4.85886 14.2782 5.07135 14.08 5.18748L8.59366 8.40215C8.22704 8.61697 7.77296 8.61697 7.40634 8.40215L1.91996 5.18748C1.72177 5.07135 1.6 4.85886 1.6 4.62916C1.6 4.12918 2.14285 3.81808 2.57424 4.07084L8 7.25L13.4258 4.07084C13.8571 3.81808 14.4 4.12918 14.4 4.62916Z" />
        </SvgContainer>
    );
};

export default Mail;
